<h1>Alpacamundo</h1>

Alpaca fokkerij Alpacamundo zet zich, 
met een selectief fokbeleid, 
in om zo gezond mogelijke dieren te fokken met een zo fijn mogelijke wol.
<p>
Op de pagina '<a routerLink="/about" routerLinkActive="active">Over ons</a>' vertellen we meer over onszelf. 
Op de pagina '<a routerLink="/alpacas" routerLinkActive="active">Onze alpaca's</a>' is alles over onze alpaca's te lezen. 
Kijk ook eens in ons <a href="https://goo.gl/photos/dir2jPpDZbZjNgZf6" target="_blank">fotoalbum</a> met
 leuke en informatieve foto's van het leven op een alpaca boerderij.
 Verder staan op onze site nog een aantal artikelen, filmpjes en foto's over alpaca's. 
 Kijk hiervoor bij <a routerLink="/info" routerLinkActive="active">'Over alpaca's'</a>.
 

<p>
  <iframe 
    width="630"
    height="370" 
    src="https://www.youtube-nocookie.com/embed/CDXf19Y0N6o?si=j9zBLjb7JXHZXAWc&amp;start=0" 
    title="YouTube video player" 
    frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
    referrerpolicy="strict-origin-when-cross-origin" 
    allowfullscreen>
  </iframe>
<p>

Alpacamundo heeft regelmatig alpaca's te koop. Zie hiervoor onze <a routerLink="/alpacas/forsale" routerLinkActive="active">verkoop</a> pagina.
<p>
Als je specifieke alpaca vragen hebt kun je altijd <a routerLink="/contact" routerLinkActive="active">contact</a> met ons opnemen. 
Dit kan door ons te bellen, WhatsAppen, e-mailen en ... langs komen kan ook, graag wel op afspraak. 
<p>
Volg je een diergerichte opleiding? Lees op de pagina <a routerLink="/students" routerLinkActive="active">School- en studieopdrachten</a> wat we te bieden hebben voor jouw opleiding. 
<p>
Anniek van Dijk & Auke Wesselink
<p> 
<h2>Alpacamundo</h2>